export default __webpack_public_path__ + "static/media/gallery-wip-handle_09.479e23ef.jpg";